
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Izvor podataka',
	'dataSourceId': 'ID',
	'dataSourceType': 'Tip',
	'dataSourceName': 'Naziv',
	'dataSourcePath': 'Staza',
	'showInfoForAll': 'Pokaži trajanje za sve vizualizacije',
	'hideInfoForAll': 'Sakrij trajanje za sve vizualizacije',
	'showPerformanceDetails': 'Ponovno izvedi sve grafičke elemente za uključivanje detalja izvedbe',
	'slotMappingField': 'Mapiranja priključnica',
	'slotDataMapping': 'Mapiranje',
	'slotID': 'ID',
	'slotCaption': 'Zaglavlje',
	'slotMandatory': 'Obavezno',
	'slotIsMandatory': 'Da',
	'slotIsNotMandatory': 'Ne',
	'infoNotAvailable': 'Nedostupno',
	'performanceSection': 'Performanse',
	'durationField': 'Trajanje',
	'singleQueryTime': 'Upit na poslužitelj (ms)',
	'multipleQueryTime': 'Upit na poslužitelj %{name} (ms)',
	'liveWidgetTotalTime': 'Ukupno (ms)',
	'renderTimeNotAvailable': 'Nedostupno',
	'renderInProgress': '(u tijeku)',
	'interactToTriggerQuery': 'Međudjelovanje s grafičkim elemenom za okidanje upita',
	'fetchQuery': 'Upit dohvaćanja',
	'showSQLMDX': 'Pokaži SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informacije upita',
	'queryInfoNotAvailable': 'Informacije upita nisu dostupne',
	'query': 'Upit',
	'copy': 'Kopiraj',
	'close': 'Zatvori'
});
